module.exports = __webpack_public_path__ + "static/trade-4-f0ccecb32c40521f099239064d80cb34.svg";